module.exports = __webpack_public_path__ + "media/assets/img/home/home_signin_left_img-ac2085b70682426b6851bec250f7ccdf.png";